import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';

@Component({
    selector: 'app-jc3-banner',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './jc3-banner.component.html',
    styleUrl: './jc3-banner.component.scss',
})
export class Jc3BannerComponent implements OnChanges {
    @Input() banners: any = {};
    desktopBanner = '';
    tabletBanner = '';

    ngOnChanges(changes): void {
        if (changes?.banners) {
            let bn = changes?.banners?.currentValue;
            this.desktopBanner = bn?.bannerdesktop;
            this.tabletBanner = bn?.bannerportrait || this.desktopBanner;
        }
    }
}
